// removed by extract-text-webpack-plugin
module.exports = {"defaultInput":"wVEITR6X","section":"pGVsGPLY","content":"_2V85Ub3w","slide":"_3iZXKbhF","row":"_2jsoddI-","textContainer":"_2YzSqzAo","text":"_1opyiMan","name":"fnG0bCCg","imgCol":"_2RYOHTYk","imgDiv":"Emq_VXrN","img":"NlzaPeVD"};


//////////////////
// WEBPACK FOOTER
// ./src/client/website/components/TestimonialsBanner/TestimonialsBanner.styl
// module id = 243
// module chunks = 0